export class QuoteApplicationSettings {
    showRoofDropdown = false;
    showYearBuilt = false;
    showHasInspection = false;
}